// ============================================================================
// SKIP LIST - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'skip-list',
  name: 'Skip List',
  category: 'Data Structures',
  complexity: {
    time: 'O(log N) average per operation',
    space: 'O(N)'
  },
  description: 'A probabilistic data structure that allows fast search within an ordered sequence. Uses multiple layers of linked lists with increasing spacing, providing O(log N) average time complexity for search, insert, and delete operations.'
};
